// Mock data for the nonprofit website. Replace with API data during backend integration.
import {
  BookOpen, Users, HeartHandshake, Baby, Sparkles, Music,
  Palette, Sprout, Calendar, HandHeart, GraduationCap, LifeBuoy,
} from "lucide-react";

export const org = {
  name: "Dallas Early Childhood Resource Institute",
  shortName: "Dallas ECRI",
  tagline: "Collaborations of Hope",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/a9tqzpey_300426691_574913640998035_51537401950798039_n.jpg",
  mission:
    "Building collaborations of hope for Dallas families — connecting young children and their caregivers to early-childhood enrichment, education, and community support.",
  phone: "972-277-9985",
  altPhone: "972-522-9984",
  email: "dallasearlychildhoodresource@gmail.com",
  address: "Attn: Development, 1234 Main Street, Lewisville, TX",
  website: "https://dallasearlychildhoodresourceinstitute.org/",
  director: "Hope F. Wharton, Founder/Director",
  hours: "Mon–Fri: 9:00am – 5:00pm • Sat: 10:00am – 2:00pm",
  ein: "501(c)(3) Nonprofit",
  socials: { facebook: "#", instagram: "#", twitter: "#", youtube: "#" },
};

export const nav = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Events", to: "/events" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "Shop", to: "/shop" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

export const products = [
  { id: "tee", name: "Collaborations of Hope Tee", price: 24, category: "Apparel", image: "https://images.unsplash.com/photo-1581655353564-df123a1eb820?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "Bestseller", description: "Soft, unisex cotton tee featuring our tree logo. Every purchase funds a class." },
  { id: "hoodie", name: "Cozy Logo Hoodie", price: 45, category: "Apparel", image: "https://images.unsplash.com/photo-1620799140188-3b2a02fd9a77?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "", description: "Warm fleece-lined hoodie in heather green. Perfect for chilly Dallas mornings." },
  { id: "tote", name: "Hope Canvas Tote", price: 18, category: "Accessories", image: "https://images.unsplash.com/photo-1574365569389-a10d488ca3fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "Eco", description: "Sturdy 100% organic cotton tote. Carry hope everywhere you go." },
  { id: "mug", name: "Morning Hope Mug", price: 14, category: "Home", image: "https://images.pexels.com/photos/9261414/pexels-photo-9261414.jpeg?auto=compress&cs=tinysrgb&w=800", badge: "", description: "11oz ceramic mug with our logo. Start each day with a little hope." },
  { id: "bottle", name: "Reusable Water Bottle", price: 22, category: "Home", image: "https://images.unsplash.com/photo-1544003484-3cd181d17917?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "Eco", description: "Insulated stainless-steel bottle that keeps drinks cold for 24 hours." },
  { id: "cap", name: "Embroidered Cap", price: 20, category: "Apparel", image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "", description: "Adjustable cap with an embroidered tree logo. One size fits most." },
  { id: "onesie", name: "Little Sprout Onesie", price: 16, category: "Kids", image: "https://images.unsplash.com/photo-1622290319146-7b63df48a635?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "New", description: "Adorable organic-cotton baby onesie. The tiniest supporters need gear too!" },
  { id: "notebook", name: "Sticker & Notebook Set", price: 12, category: "Accessories", image: "https://images.unsplash.com/photo-1612367980327-7454a7276aa7?crop=entropy&cs=srgb&fm=jpg&q=85&w=800", badge: "", description: "A dotted notebook plus a sheet of playful logo stickers." },
];

export const heroImages = {
  main: "https://images.pexels.com/photos/1181738/pexels-photo-1181738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  about: "https://images.pexels.com/photos/3661452/pexels-photo-3661452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aboutSecondary: "https://images.unsplash.com/photo-1527490087278-9c75be0b8052?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxwYXJlbnRzJTIwY2hpbGRyZW58ZW58MHx8fHwxNzkwMjYzNjk0fDA&ixlib=rb-4.1.0&q=85",
  volunteer: "https://images.unsplash.com/photo-1560220604-1985ebfe28b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx2b2x1bnRlZXJzJTIwY29tbXVuaXR5fGVufDB8fHx8MTc5MDI2MzczN3ww&ixlib=rb-4.1.0&q=85",
  donate: "https://images.pexels.com/photos/7345399/pexels-photo-7345399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  event: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Save the Date flyer (user-provided). Displayed cropped to hide the QR/payment section.
export const eventFlyer = "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/oo6qe4wk_ECLD_Save_the_Date_Original_QRs_Uniform%20%281%29%20%281%29.png";

// Press-release / registration flyer (user-provided) — shows Registration: $49 details.
export const pressFlyer = "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/92e3199234a8df9f_1000012437%20%281%29.png";

// Highlight reel for the upcoming ECLD Network Event (web-optimized, ~10MB / 720p).
export const eventVideo = `${process.env.PUBLIC_URL || ""}/ecld-highlight.mp4`;

// Site background music (user-provided).
export const siteMusic = "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/fgvtkn69_Strong%20at%20the%20Root.mp3";
export const siteMusicTitle = "Strong at the Root";

// Ways to Pay graphic (user-provided) — Zelle, Venmo, Cash App QR codes.
export const waysToPayImage = "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/8kep6w2u_Ways_to_Pay_16x9_Original_QRs.png";

// Individual payment QR codes (user-provided).
export const paymentMethods = [
  {
    name: "Zelle",
    qr: "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/0fba8910ca60d0c0_1000012508%20%281%29.jpg",
    note: "Scan with your banking app",
  },
  {
    name: "Venmo",
    qr: "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/b898d7ca89f6fd41_1000012509.jpg",
    note: "Scan in the Venmo app",
  },
  {
    name: "Cash App",
    qr: "https://customer-assets-39nsmqrw.emergentagent.net/job_charity-connect-156/artifacts/b0ab35a9db8e3276_1000012510.png",
    note: "Scan in Cash App",
  },
];

export const stats = [
  { value: "3,500+", label: "Families served each year" },
  { value: "40+", label: "Weekly classes & programs" },
  { value: "20+", label: "Years serving our community" },
  { value: "120", label: "Volunteers & educators" },
];

export const programs = [
  {
    id: "early-learners",
    icon: Baby,
    title: "Early Learners",
    age: "Ages 0–2",
    color: "bg-teal-50 text-teal-700",
    short: "Sensory play, music, and bonding classes for babies and their caregivers.",
    description:
      "Gentle, caregiver-led sessions that nurture early development through sensory play, songs, and social connection in a warm, welcoming space.",
    image: "https://images.unsplash.com/photo-1600880291319-1a7499c191e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHx0b2RkbGVycyUyMHBsYXlpbmd8ZW58MHx8fHwxNzkwMjYzNjkzfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "toddler-time",
    icon: Sprout,
    title: "Toddler Time",
    age: "Ages 2–4",
    color: "bg-amber-50 text-amber-700",
    short: "Playgroups that build language, motor skills, and friendships.",
    description:
      "Structured playgroups where toddlers explore, create, and grow their independence while caregivers connect and share.",
    image: "https://images.pexels.com/photos/3661452/pexels-photo-3661452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "creative-arts",
    icon: Palette,
    title: "Creative Arts",
    age: "Ages 3–6",
    color: "bg-rose-50 text-rose-700",
    short: "Hands-on art, movement, and imaginative play for growing minds.",
    description:
      "Messy, joyful art and movement classes that spark creativity and confidence for our youngest artists.",
    image: "https://images.pexels.com/photos/8535626/pexels-photo-8535626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "music-together",
    icon: Music,
    title: "Music Together",
    age: "All ages",
    color: "bg-sky-50 text-sky-700",
    short: "Family music-making that builds rhythm, language, and joy.",
    description:
      "Interactive, research-based music classes the whole family can enjoy together, building a lifelong love of music.",
    image: "https://images.unsplash.com/photo-1527490087278-9c75be0b8052?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxwYXJlbnRzJTIwY2hpbGRyZW58ZW58MHx8fHwxNzkwMjYzNjk0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "parent-support",
    icon: HeartHandshake,
    title: "Parent Support Circles",
    age: "Caregivers",
    color: "bg-teal-50 text-teal-700",
    short: "Peer support groups led by experienced family educators.",
    description:
      "Safe, welcoming circles where new and expecting parents find guidance, friendship, and community.",
    image: "https://images.pexels.com/photos/27175805/pexels-photo-27175805.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "school-readiness",
    icon: GraduationCap,
    title: "School Readiness",
    age: "Ages 4–5",
    color: "bg-amber-50 text-amber-700",
    short: "Preparing children and families for a confident start to school.",
    description:
      "A play-based curriculum that builds the social, emotional, and pre-academic skills children need to thrive in kindergarten.",
    image: "https://images.pexels.com/photos/8535626/pexels-photo-8535626.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const events = [
  {
    id: "ecld-network-event",
    featured: true,
    title: "Early Childhood Leaders–Directors (ECLD) Network Event",
    tagline: "Where Early Childhood Leaders Connect, Grow, and Lead Forward",
    date: "2026-10-24",
    time: "8:00 AM – 1:00 PM",
    location: "Energy Square One Bldg., 4925 Greenville Avenue, Dallas, TX 75206",
    category: "Networking",
    price: "$49 / person",
    image: "https://images.pexels.com/photos/1181738/pexels-photo-1181738.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Join 100+ early childhood directors, educators, and community partners for a powerful day of leadership development, collaboration, and resource sharing. Limited seating — advance registration required.",
    highlights: ["Build Partnerships", "Share Ideas", "Strengthen Leadership", "Support Children & Families"],
  },
  {
    id: "family-fun-day",
    title: "Spring Family Fun Day",
    date: "2026-04-18",
    time: "11:00 AM – 3:00 PM",
    location: "Dallas Community Park",
    category: "Community",
    price: "Free",
    image: "https://images.unsplash.com/photo-1573497701240-345a300b8d36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    description: "A day of games, music, face painting, and food trucks for the whole family.",
  },
  {
    id: "new-parent-workshop",
    title: "New Parent Workshop",
    date: "2026-05-09",
    time: "6:30 PM – 8:00 PM",
    location: "Dallas ECRI Center",
    category: "Workshop",
    price: "Free",
    image: "https://images.pexels.com/photos/27175805/pexels-photo-27175805.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "Expert-led session on sleep, feeding, and building routines for newborns.",
  },
  {
    id: "annual-gala",
    title: "Annual Fundraising Gala",
    date: "2026-09-12",
    time: "7:00 PM – 10:00 PM",
    location: "The Grand Hall, Dallas",
    category: "Fundraiser",
    price: "$95",
    image: "https://images.pexels.com/photos/7345447/pexels-photo-7345447.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description: "An elegant evening celebrating our families and the year ahead.",
  },
  {
    id: "storytime-park",
    title: "Storytime in the Park",
    date: "2026-06-06",
    time: "10:00 AM – 11:00 AM",
    location: "Katy Trail Green, Dallas",
    category: "Program",
    price: "Free",
    image: "https://images.unsplash.com/photo-1600880291319-1a7499c191e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHx0b2RkbGVycyUyMHBsYXlpbmd8ZW58MHx8fHwxNzkwMjYzNjkzfDA&ixlib=rb-4.1.0&q=85",
    description: "Bring a blanket and join us for songs, stories, and snacks outdoors.",
  },
];

export const involveOptions = [
  { icon: HandHeart, title: "Volunteer", text: "Give your time in classrooms, events, and behind the scenes." },
  { icon: Users, title: "Become a Member", text: "Join our community and enjoy member-only programs and discounts." },
  { icon: HeartHandshake, title: "Partner With Us", text: "Corporate and community partnerships that create real impact." },
  { icon: Sparkles, title: "Fundraise", text: "Start a personal campaign and rally friends around our mission." },
];

export const donationTiers = [
  { amount: 25, label: "Provides art supplies for a class" },
  { amount: 50, label: "Sponsors a family for a month of classes" },
  { amount: 100, label: "Funds a parent support circle session" },
  { amount: 250, label: "Supports a full scholarship for a child" },
];

export const testimonials = [
  {
    name: "Maya R.",
    role: "Parent of two",
    quote:
      "Bright Beginnings gave me a community when I needed it most. My kids light up every time we walk through the doors.",
  },
  {
    name: "Daniel K.",
    role: "First-time dad",
    quote:
      "The parent support circle helped me feel confident and connected. I found friends who truly get it.",
  },
  {
    name: "Priya S.",
    role: "Grandparent & caregiver",
    quote:
      "Warm, welcoming, and so well run. The educators genuinely care about every family that walks in.",
  },
];

export const team = [
  { name: "Elena Fisher", role: "Executive Director", initials: "EF" },
  { name: "Marcus Bell", role: "Program Director", initials: "MB" },
  { name: "Aisha Patel", role: "Family Educator", initials: "AP" },
  { name: "Tom Reyes", role: "Volunteer Coordinator", initials: "TR" },
];

export const partners = [
  "Dejana Family Foundation",
  "Community Chest",
  "Pine Tree Foundation",
  "Riverdale Pediatrics",
  "M&T Charitable Fund",
  "Whole Foods",
  "Junior League",
  "Zucker Foundation",
];

export const resources = [
  { icon: BookOpen, category: "Guides", title: "New Parent Starter Guide", text: "Everything you need in the first 6 months." },
  { icon: LifeBuoy, category: "Support", title: "Local Family Support Directory", text: "Trusted services across our community." },
  { icon: Calendar, category: "Planning", title: "Developmental Milestones Chart", text: "Track growth from birth to age 5." },
  { icon: GraduationCap, category: "Education", title: "Kindergarten Readiness Checklist", text: "Prepare your child for a strong start." },
  { icon: HeartHandshake, category: "Wellness", title: "Caregiver Self-Care Toolkit", text: "Because caregivers need care too." },
  { icon: Baby, category: "Health", title: "Feeding & Sleep Basics", text: "Practical tips from our educators." },
];

export const faqs = [
  { q: "Do I need to be a member to attend classes?", a: "Many of our programs are open to all families. Members enjoy discounts and priority registration, but drop-ins are always welcome." },
  { q: "Are your programs affordable?", a: "Yes. We offer sliding-scale pricing and full scholarships so that cost is never a barrier to participation." },
  { q: "What ages do you serve?", a: "We serve families with children from birth through age six, plus support programs for all caregivers." },
  { q: "How can I volunteer?", a: "Visit our Get Involved page to fill out a short interest form. Our volunteer coordinator will follow up within a few days." },
];
